/* eslint-disable  */
import { styled } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { Appbar } from 'components';
import Navbar from 'components/sidebar';

const PrivateLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-screen h-[screen] flex flex-col gap-0">
      <Appbar />
      <div className="flex flex-row items-start justify-between h-[92vh] bg-gradient-to-br from-[#eeeeee] via-[#edf1f5] to-[#e8ecf0] overflow-y-hidden">
        <Navbar />
        <div className="flex items-start h-[84vh] w-[92%] mx-[2%] my-[4vh] shadow-elevated rounded-sm bg-white overflow-y-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
